import * as actionTypes from "../actions/actionTypes";

const initialState = {
  withdrawaldata: null,
};

export default (state = initialState, action = {}) => {

  switch (action.type) {
    case actionTypes.SAVE_WITHDRAWAL_DATA:
      return {
        ...state,
        withdrawaldata: action.data,
      };


      
    default:
      return state;
  }
};
